import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../styles/components/QuillEditor.scss";
import React, { useRef } from "react";
import { useDeepEffect } from "../../abstracts";
import QuillImageDropAndPaste from "quill-image-drop-and-paste";
//import ImageResize from 'quill-image-resize-module-react';

const QuillEditor = ({ data, setData, metaData, isSubmit, values, name }) => {
  //const metaData = ["{FirstName}", "{LastName}", "{Plan}", "{PlanGroup}"];
  const x = useRef(data);
  const root = document.documentElement;
  const Quill = ReactQuill.Quill;
  Quill.register("modules/imageDropAndPaste", QuillImageDropAndPaste);
  //Quill.register('modules/imageResize', ImageResize);
  const placeholderPickerItems = Array.prototype.slice.call(
    document.querySelectorAll(".ql-placeholder .ql-picker-item")
  );

  placeholderPickerItems.forEach(
    (item) => (item.textContent = item.dataset.value)
  );
  if (document.querySelector(".ql-placeholder .ql-picker-label") != null)
    document.querySelector(".ql-placeholder .ql-picker-label").innerHTML =
      "Insert placeholder" +
      document.querySelector(".ql-placeholder .ql-picker-label").innerHTML;
  const modules = {
    imageDropAndPaste: {
      //drag and drop image
      handler: function (value) {
        let index = (this.quill.getSelection() || {}).index;
        if (index === undefined || index < 0) index = this.quill.getLength();
        this.quill.insertEmbed(index, "image", value.data, "user");
      },
    },
    toolbar: {
      container: [
        [{ size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }, { align: [] }],
        ["blockquote", "link", "image", "code-block", "video"],
        ["clean"],
        [{ placeholder: metaData }],
      ],
      handlers: {
        placeholder: function (value) {
          if (value) {
            const cursorPosition = this.quill.getSelection().index;
            root?.style.setProperty("--content", value);
            this.quill.insertText(cursorPosition, value);
            this.quill.setSelection(cursorPosition + value.length);
          }
        },
      },
    },
  };

  const formats = [
    //"header",
    "size",
    "font",
    "bold",
    //"placeholder",
    "color",
    "italic",
    "underline",
    "strike",
    "background",
    "code",
    "list",
    "bullet",
    "blockquote",
    //"indent",
    "link",
    "image",
    "align",
    "video",
    "code-block",
    "clean",
  ];

  const Change = (html) => {
    x.current = html;
    values[name] = html;
  };
  useDeepEffect(
    () => {
      setData(x.current);
    },
    [isSubmit],
    true
  );

  return (
    <ReactQuill
      modules={modules}
      formats={formats}
      //readOnly={readOnly}
      defaultValue={data}
      onChange={Change}
      //placeholder={placeholderPickerItems}
      style={{ width: "100%" }}
    />
  );
};

export default QuillEditor;
